import styled from 'styled-components';
import { device } from '../../styles/stylesheets';

export const Container = styled.div`
  margin: 0 auto;
  
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 40px;
  width: 90%;
  margin: 0 auto;
  > :first-child {
    margin-top: 40px;
  }
  @media ${device.untilLaptop} {
    width: 100%;
  }
  @media ${device.untilMobileL} {
    padding: 0 15px;
  }
`;

export const ContentSpinner = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 12vh;
`;

export const ContentSubtitle = styled.div`
  margin: 64px 0 40px;
  font-size: 24px;
  line-height: 36px;
  @media ${device.untilTablet} {
    font-size: 20px;
    margin-bottom: 20px;
  }
`;

export const ServiceSubtitle = styled(ContentSubtitle)`
  font-size: 20px;
  line-height: 30px;
  margin-bottom: 20px;
  font-weight: 500;
`;

export const HelpCenter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  margin: 40px 0 20px;
  > * {
    padding-left: 20px;
    margin-bottom: 20px;
  }
  @media ${device.untilTablet} {
    justify-content: center;
  }
`;
